import { Link, withPrefix } from "gatsby"
import PropTypes from "prop-types"
import React from "react"

const Header = ({ siteTitle }) => (
  <header
    style={{
      boxSizing: "border-box",
      backgroundImage: `url(${withPrefix('/img/back.jpg')})`,
      height: 70,
    }}
  >
    <div
      style={{
        background: `rgba(52, 183, 235, 0.9)`,
        height: "100%",
      }}
    >
      <div
        style={{
          margin: `0 auto`,
          maxWidth: 960,
          height: "100%",
        }}
      >
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%", margin: 0, fontWeight: 800, fontSize: 26 }}>
          <a
            href="https://brilacasck.github.io"
            style={{
              color: `white`,
              textDecoration: `none`,
              marginRight: 20,
            }}
          >
            Brilacasck
          </a>
          <Link
            to="/"
            style={{
              color: `white`,
              textDecoration: `none`,
            }}
          >
            About
          </Link>
        </div>
      </div>
    </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
